import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import cookies from 'js-cookie';
import { AUTH_LOGIN } from '../../api';
import Preloader from '../../components/Preloader/Preloader';

const AuthLoginPage = ({ store }) => {
    const history = useHistory();

    function authLogin(login, sessionId, roles) {
        AUTH_LOGIN(login, sessionId)
            .then((data) => {
                if (data.success === true) {
                    if (roles.includes('SP_Seller')) {
                        const user = { isSeller: true };
                        store.profile.setUser(user);
                        history.push('/sales');
                    } else if (roles.includes('SP_Supervisor')) {
                        const user = { isSupervisor: true };
                        store.profile.setUser(user);
                        history.push('/supervisor/sales');
                    } else {
                        history.push('/login');
                    }
                } else {
                    history.push('/login');
                }
            }).catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        const login = cookies.get('login');
        const sessionId = cookies.get('sessionId');

        const encodedRoles = cookies.get('roles');
        let roles = [];

        if (login) {
            cookies.remove('login');
        }
        if (sessionId) {
            cookies.remove('sessionId');
        }
        if (encodedRoles) {
            const decodedRoles = decodeURIComponent(encodedRoles);
            roles = JSON.parse(decodedRoles);
            cookies.remove('roles');
        }

        if (login && sessionId && roles.length > 0) {
            authLogin(login, sessionId, roles);
        }
    });

    return (<Preloader/>);
};

export default withRouter(inject('store')(observer(AuthLoginPage)));
